import CustomDropdownInput from "components/CustomDropdownInput";
import CustomTextInput from "components/CustomTextInput";
import React from "react";
import { Row, Col } from "reactstrap";
import t from "utils/Lang";

type OtherFeeProps = {
  depositTypes: Array<any>;
  updateAttr: (attribute: string, value: any) => void;
  data: any;
  errorData: any;
  isViewContract: boolean;
  fieldIsInvalid: (err: any) => boolean;
};

const OtherFee = ({
  depositTypes,
  updateAttr,
  data,
  errorData,
  isViewContract,
  fieldIsInvalid,
}: OtherFeeProps) => {
  const uiConfigs = [
    {
      attributeName: "deposit_fee",
      type: "text",
      label: t().contract_deposit + " *",
      isNumeric: true,
      size: 6,
      isDisabled: false,
    },
    {
      attributeName: "contract_deposit_type_id",
      type: "dropdown",
      options: depositTypes.map((type) => ({
        label: type.name,
        value: type.id,
      })),
      label: t().deposit_method,
      size: 6,
    },
    {
      attributeName: "contract_deposit_attribute_to_month",
      type: "text",
      label: t().deposit_attribute_to_month + " *",
      isNumeric: true,
      size: 6,
      inactive: data.contract_deposit_type_id
        ? depositTypes.find((el) => el.id === data.contract_deposit_type_id)
            ?.code !== "deduct_in_rental_fee"
        : true,
    },
    {
      attributeName: "management_fee",
      type: "text",
      label: t().management_fee,
      isNumeric: true,
      size: 6,
    },
  ];

  return (
    <>
      <h4 className="site-summary__label-title">{t().other_fee}</h4>
      <Row>
        {uiConfigs
          .filter((el) => !el.inactive)
          .map((layoutItem, idx) => {
            if (layoutItem.type == "dropdown") {
              return (
                <Col
                  key={layoutItem.attributeName || `${idx}`}
                  sm={{ size: layoutItem.size, offset: 0 }}
                >
                  <CustomDropdownInput
                    callback={updateAttr}
                    data={data}
                    options={layoutItem.options || []}
                    labelText={layoutItem.label}
                    attributeName={layoutItem.attributeName}
                    invalid={fieldIsInvalid(
                      errorData?.[layoutItem.attributeName]
                    )}
                    formFeedbackText={errorData?.[layoutItem.attributeName]}
                    disabled={isViewContract}
                  />
                </Col>
              );
            } else {
              return (
                <Col
                  key={layoutItem.attributeName || `${idx}`}
                  sm={{ size: layoutItem.size, offset: 0 }}
                >
                  <CustomTextInput
                    key={layoutItem.attributeName || `${idx}`}
                    disabled={isViewContract || layoutItem.isDisabled}
                    type={layoutItem.type}
                    isNumeric={layoutItem.isNumeric || false}
                    callback={updateAttr}
                    data={data}
                    labelText={layoutItem.label}
                    attributeName={layoutItem.attributeName}
                    invalid={fieldIsInvalid(
                      errorData?.[layoutItem.attributeName]
                    )}
                    formFeedbackText={errorData?.[layoutItem.attributeName]}
                  />
                </Col>
              );
            }
          })}
      </Row>
    </>
  );
};

export default OtherFee;
